(function () {
  function setOpen(card, open) {
    var btn = card.querySelector('.lx-adv__plus');
    card.classList.toggle('is-open', open);
    if (btn) btn.setAttribute('aria-expanded', String(open));
  }

  document.querySelectorAll('.lx-adv__plus').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var card = btn.closest('.lx-adv__card');
      if (card) setOpen(card, !card.classList.contains('is-open'));
    });
  });

  document.querySelectorAll('.lx-adv__card:not(.lx-adv__card--toggle) .lx-adv__media').forEach(function (media) {
    media.addEventListener('click', function () {
      var card = media.closest('.lx-adv__card');
      if (card) setOpen(card, !card.classList.contains('is-open'));
    });
  });

  document.querySelectorAll('.lx-adv__lamp-toggle').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var card = btn.closest('.lx-adv__card--toggle');
      if (!card) return;
      var isOn = btn.getAttribute('aria-pressed') === 'true';
      btn.setAttribute('aria-pressed', String(!isOn));
      card.classList.toggle('is-on', !isOn);
      card.classList.add('is-touched');
      var hint = card.querySelector('.lx-adv__hint');
      if (hint) hint.textContent = !isOn ? 'Tap to switch it off' : 'Tap to light it up';
    });
  });
})();
